import { createClient, type SupportedStorage } from '@supabase/supabase-js';

const customStorageAdapter: SupportedStorage = {
    //@ts-ignore
    getItem: (key: string) => {
        if (!supportsLocalStorage()) {
            const value = "; " + document.cookie;
            const parts = value.split("; " + key + "=");
            
            if (parts.length === 2) {
                return parts.pop()?.split(";").shift();
            }
            return null;
        }
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key: string, value: string) => {
        if (!supportsLocalStorage()) {
            const date = new Date();

            // Set to expire in 7 days
            date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
            document.cookie = key+"="+value+"; expires="+date.toUTCString()+"; path=/";
            return;
        }
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key: string) => {
        if (!supportsLocalStorage()) {
            const date = new Date();
        
            // Set to expire in -1 days
            date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
            document.cookie = name+"=; expires="+date.toUTCString()+"; path=/";
            return;
        }
        globalThis.localStorage.removeItem(key);
    }
}

function supportsLocalStorage(): boolean {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    }
    catch(e) {
        return false;
    }
}

export const supabase = createClient(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_ANON_KEY,
    {
        auth: {
            detectSessionInUrl: true,
            flowType: 'pkce',
            storage: customStorageAdapter
        }
    }
);